import styled from 'styled-components/macro'
import { compose, margin, space, typography } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'
import palette from 'src/designSystem/variables/palette'
import { CheckSVG } from 'src/components/Icons/Basic'

export const ButtonGroup = styled.div<{
  $mt?: number
  $mb?: number
  $ml?: number
  $mr?: number
}>`
  display: flex;
  align-items: flex-end;
  padding: 0;
  margin: 0;

  ${({ $mt }) => $mt && `margin-top: ${$mt}px`};
  ${({ $mb }) => $mb && `margin-bottom: ${$mb}px`};
  ${({ $ml }) => $ml && `margin-left: ${$ml}px`};
  ${({ $mr }) => $mr && `margin-right: ${$mr}px`};

  > :last-child {
    ${margin}
  }
`

export const Filter = styled.ul.attrs({
  role: 'tablist',
})<{ $numItems?: number }>`
  display: flex;
  margin: 0;
  padding: 0;
  width: fit-content;
  height: 40px;
  border-radius: 100px;
  > :first-child {
    border-radius: 100px 0 0 100px;
    border-right: 1px solid ${palette.neutral[300]};
  }
  > :last-child {
    border-radius: 0 100px 100px 0;
  }
  > :not(:first-child):not(:last-child) {
    border-right: 1px solid ${palette.neutral[300]};
    border-radius: 0;
  }
  border: 1px solid ${palette.neutral[300]};
  background-color: ${palette.neutral.white};
  overflow: hidden;
`

export const FilterButtonIcon = styled(CheckSVG).attrs({
  className: 'filter-button-icon',
})`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  path {
    fill: ${palette.neutral[900]};
  }
`

export const FilterButtonText = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const FilterButton = styled.div.attrs({
  px: 'xs',
  fontSize: '3',
})<{ $isDisabled?: boolean }>`
  ${compose(space, typography)}
  display: flex;
  width: fit-content;
  ${(props) => {
    const isActive =
      typeof props.className === 'string' &&
      props.className.includes('active-tab')
    return isActive
      ? `
    gap: 8px;`
      : `gap: 0;`
  }}
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 12px 24px;
  border-radius: inherit;
  text-decoration: none;
  cursor: pointer;
  color: ${palette.neutral[900]} !important;

  font-size: 14px;
  font-weight: 400;

  span {
    z-index: 3;
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: inherit;
  }

  .filter-button-icon {
    display: none;
  }

  &.active-tab {
    padding: 12px;
    span {
      font-weight: 500;
    }
    .filter-button-icon {
      display: block;
      z-index: 3;
      path {
        fill: ${palette.neutral[900]};
      }
    }
  }
  &.active-tab::after {
    background-color: ${palette.neutral[50]};
  }
  &:not(.active-tab):hover {
    background-color: ${palette.neutral.white};
  }
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
  pointer-events: none;
  opacity: 0.5;
  `}
`

export const FilterOld = styled.ul.attrs({
  role: 'tablist',
})<{ $numItems?: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$numItems || 2}, 1fr);
  margin: 0;
  padding: 0;
  border-radius: 0 100px 100px 0;
  background-color: ${(props) => props?.theme?.colors?.border?.neutral?.base};
  overflow: hidden;
`

export const FilterButtonOld = styled.div.attrs({
  px: 'xs',
  fontSize: '3',
})<{ $translateFrom: 'right' | 'left'; $isDisabled?: boolean }>`
  ${compose(space, typography)}
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 7px;
  border-radius: inherit;
  color: white !important;
  text-decoration: none;
  cursor: pointer;

  font-size: 12px;
  font-weight: 600;

  span {
    z-index: 3;
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: inherit;
  }

  &.active-tab::after {
    background-color: ${themeGet('colors.fill.neutral.extraDark')};
  }
  &:not(.active-tab):hover {
    background-color: ${themeGet('colors.fill.neutral.base')};
  }
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
  pointer-events: none;
  opacity: 0.5;
  `}
`
